import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { formatCatalogItemDate } from '@cp/entities/catalogItem';
import { CreatedAtProps } from './model';

export const CreatedAt: React.FC<CreatedAtProps> = ({ data, sx }) => {
  if (!data.createdAt) {
    return null;
  }

  const createdAt = new Date(data.createdAt);

  return (
    <Typography sx={mergeSx({ color: 'gray', whiteSpace: 'nowrap' }, sx)} variant="small text">
      Добавлено {formatCatalogItemDate(createdAt)}
    </Typography>
  );
};
